import { WebStorageStateStore } from 'oidc-client';

const oidcSettingsFile = JSON.parse(process.env.VUE_APP_OIDC_CONFIG)

export const oidcSettings = {
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    authority: oidcSettingsFile.authority,
    clientId: oidcSettingsFile.clientId,
    redirectUri: oidcSettingsFile.redirectUri,
    popupRedirectUri: oidcSettingsFile.popupRedirectUri,
    responseType: oidcSettingsFile.responseType,
    scope: oidcSettingsFile.scope,
    automaticSilentRenew: oidcSettingsFile.automaticSilentRenew,
    automaticSilentSignin: oidcSettingsFile.automaticSilentSignin,
    silentRedirectUri: oidcSettingsFile.silentRedirectUri,
    loadUserInfo: oidcSettingsFile.loadUserInfo,
    revokeAccessTokenOnSignout: oidcSettingsFile.revokeAccessTokenOnSignout,
    monitorSession: oidcSettingsFile.monitorSession,
    filterProtocolClaims: oidcSettingsFile.filterProtocolClaims,
    extraQueryParams: {
        "App-Type": oidcSettingsFile.apptype, "Base-Url": oidcSettingsFile.baseurl, "Custom-View": oidcSettingsFile.customView
    }
};
